import { Formik, useFormikContext } from 'formik';
import { ReactElement, useEffect } from 'react';
import { useIsMobile } from '@synergy/components-next';

import { ChangePasswordDrawer } from './change-password-drawer';
import { ChangePasswordFormValues } from './models/change-password-form-values';
import { ChangePasswordModal } from './change-password-modal';
import { changePassword, closeChangePasswordModal } from '../../../store/change-password-actions';
import { changePasswordSelector } from '../../../store/change-password-selectors';
import { changePasswordValidationSchema } from './change-password-validation-schema';
import { useAppDispatch, useAppSelector } from '../../../../store/store';

const FormikReset = ({ isOpen }: { isOpen: boolean }): null => {
    const { resetForm } = useFormikContext();

    useEffect(() => {
        resetForm();
    }, [isOpen, resetForm]);

    return null;
};

export const ChangePassword = (): ReactElement | null => {
    const { isOpen, initialValues } = useAppSelector(changePasswordSelector);
    const isMobile = useIsMobile();
    const dispatch = useAppDispatch();

    const handleClose = (): void => {
        dispatch(closeChangePasswordModal());
    };

    const handleSubmit = (values: ChangePasswordFormValues): void => {
        dispatch(changePassword(values));
    };

    return (
        <Formik
            initialValues={initialValues}
            onSubmit={handleSubmit}
            validationSchema={changePasswordValidationSchema}
            enableReinitialize={true}
        >
            <>
                <FormikReset isOpen={isOpen} />
                {isMobile ? (
                    <ChangePasswordDrawer onClose={handleClose} />
                ) : (
                    <ChangePasswordModal onClose={handleClose} />
                )}
            </>
        </Formik>
    );
};
